// extracted by mini-css-extract-plugin
export default {"container":"AdminMailingModal_container__wX-EG","buttonsGroup":"AdminMailingModal_buttonsGroup__yTj-w"};